import type { BranchAccess } from '../../shell/session/store/sessionTypes';

export type BranchAccessPatch = Partial<
  Pick<
    BranchAccess,
    | 'name'
    | 'location'
    | 'latitude'
    | 'longitude'
    | 'stockSalePolicy'
    | 'barcodeInputMode'
    | 'scaleBarcodeProfile'
    | 'manualDiscountMaxPercent'
    | 'manualDiscountMaxAmount'
    | 'consolidateCartLines'
    | 'kitchenFireMode'
    | 'kitchenAutoArchiveOnDelivered'
    | 'sellableModifierAssumption'
  >
>;

/** Aplica un patch local a la sucursal activa (offline-first; evita refetch con caché stale). */
export function applyBranchAccessPatch(
  branches: BranchAccess[],
  branchId: string,
  patch: BranchAccessPatch
): BranchAccess[] {
  return branches.map((branch) => (branch.id === branchId ? { ...branch, ...patch } : branch));
}

export function validateBranchNameForSave(name: string): { ok: true; value: string } | { ok: false; reason: 'empty' } {
  const value = name.trim();
  if (!value) return { ok: false, reason: 'empty' };
  return { ok: true, value };
}

export function canMutateBranchSettings(canEdit: boolean, branchId: string | null | undefined): boolean {
  return Boolean(canEdit && branchId);
}

// #1463: los resolvers de KPI de integraciones se eliminaron junto con el
// KPI strip del hub — las filas TicketListRow muestran el estado real directo.
